jQuery(function ($) {
    var html = $('html');
    var nav = $('.site-header .main .nav');
    var menu = nav.find('> .menu');
    var button = nav.find('> .toggle');
    var enabled = 'nav-toggle-enabled';
    var hidden = '-hidden';

    if (nav.length === 0 || menu.length === 0) {
        return;
    }

    if (button.length === 0) {
        button = $('<a href="#" class="toggle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Menu</title><path d="M 3,6L 21,6L 21,8L 3,8L 3,6 Z M 3,11L 21,11L 21,13L 3,13L 3,11 Z M 3,16L 21,16L 21,18L 3,18L 3,16 Z "/></svg></a>');
        nav.prepend(button);
    }

    button.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        menu.toggleClass(hidden);
    });

    html.on('click', function (e) {
        menu.addClass(hidden);
    });

    html.addClass(enabled);
    menu.addClass(hidden);
});
